import { Parser } from '~/api';
import { Allocation } from '~/api/models';
import RequestService from './request';

interface FetchSelectorAllocationsRequest {
    node: number;
    in_use?: boolean;
    ip_port?: string;
}

interface CreateAllocationRequest {
    ip: string[];
    alias?: string;
    ports: string[];
}

interface UpdateAllocationRequest {
    id: number;
    alias: string;
}

interface MassDeleteAllocationsRequest {
    allocations?: number[];
    ips?: string[];
}

interface DeleteAllocationRequest {
    id: number;
}

export interface AvailableIp {
    ip: string;
    free: number;
}

class NodeAllocationsService {
    getAll(req: PaginatableRequest): Promise<Allocation[]> {
        return RequestService.get('/nodes/:node/allocations', {
            ...req,
            include: 'server,firewallRules',
        }).then(Parser.parse);
    }

    getAllForSelector(data: FetchSelectorAllocationsRequest): Promise<Allocation[]> {
        return RequestService.get(`/nodes/${data.node}/allocations`, {
            ['filter[ip_port]']: data.ip_port,
            ['filter[in_use]']: data.in_use,
        }).then(Parser.parse);
    }

    ips(): Promise<string[]> {
        return RequestService.get('/nodes/:node/allocations/ips');
    }

    availableIps(node: number | string): Promise<AvailableIp[]> {
        return RequestService.get(`/nodes/${node}/allocations/available-ips`);
    }

    create(data: CreateAllocationRequest): Promise<Allocation[]> {
        return RequestService.post('/nodes/:node/allocations', data).then((res) => Parser.parse(res, true));
    }

    update(data: UpdateAllocationRequest): Promise<Allocation> {
        return RequestService.put(`/nodes/:node/allocations/${data.id}?include=server,firewallRules`, data).then(Parser.parse);
    }

    massDelete(data: MassDeleteAllocationsRequest): Promise<void> {
        return RequestService.delete('/nodes/:node/allocations', { data });
    }

    delete(data: DeleteAllocationRequest): Promise<void> {
        return RequestService.delete(`/nodes/:node/allocations/${data.id}`);
    }
}

export default new NodeAllocationsService();
